import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { paths } from '@/routes/paths';
import { Logo, LOGO_SIZE } from '@/shared/components/logo';

const FOOTER_LINKS = [
  { key: 'privacy', to: paths.legal.privacy },
  { key: 'terms', to: paths.legal.terms },
  { key: 'contact', to: paths.contact },
] as const;

export function Footer() {
  const { t } = useTranslation('landing');

  return (
    <Box
      component="footer"
      sx={{
        position: 'relative',
        zIndex: 5,
        px: { xs: 2.5, md: 5 },
        py: 4,
        mt: 'auto',
        borderTop: 1,
        borderTopColor: 'divider',
      }}
    >
      <Container maxWidth="lg" disableGutters>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          justifyContent="space-between"
          spacing={2}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <Logo size={LOGO_SIZE.inline} />
            <Typography sx={{ fontSize: 13, color: 'text.secondary' }}>
              {t('footer.copyright')}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={3}>
            {FOOTER_LINKS.map(({ key, to }) => (
              <Link
                key={key}
                component={RouterLink}
                to={to}
                underline="none"
                sx={{
                  fontSize: 13,
                  color: 'text.secondary',
                  '&:hover': { color: 'text.primary' },
                }}
              >
                {t(`footer.links.${key}`)}
              </Link>
            ))}
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
